import { ChangeEvent, Dispatch, SetStateAction, useState } from 'react';
import { SelectedPermissionType, UserTypeType } from '../../types';
import useErrors from '../../../../../../hooks/useErrors';
import formatCpf from '../../../../../../utils/formatCpf';
import isCpfvalid from '../../../../../../utils/isCpfValid';
import isEmailValid from '../../../../../../utils/isEmailValid';
import { toast } from 'react-toastify';

interface IUseInputChanges {
  selectedPermissions: SelectedPermissionType[],
  adminPermissions: SelectedPermissionType[],
  setSelectedPermissions: Dispatch<SetStateAction<SelectedPermissionType[]>>,
  defaultPermissions: SelectedPermissionType[],
}

export default function useInputChanges({
  selectedPermissions,
  adminPermissions,
  setSelectedPermissions,
  defaultPermissions,
}: IUseInputChanges) {
  const [name, setName] = useState('');
  const [cpf, setCpf] = useState('');
  const [email, setEmail] = useState('');
  const [type, setType] = useState<UserTypeType>({ value: 2, label: 'Padrão' });

  const {
    setError, removeError, getErrorMessageByFieldName, errors,
  } = useErrors();

  function handleNameChange(event: ChangeEvent<HTMLInputElement>) {
    setName(event.target.value);
    if (!event.target.value) {
      setError({ field: 'name', message: 'Nome é obrigatório!' });
    } else {
      removeError('name');
    }
  }

  function handleCpfChange(event: ChangeEvent<HTMLInputElement>) {
    setCpf(formatCpf(event.target.value));
    if (!event.target.value) {
      setError({ field: 'cpf', message: 'CPF é obrigatório!' });
    } else if (!isCpfvalid(formatCpf(event.target.value))) {
      setError({ field: 'cpf', message: 'CPF inválido!' });
    } else {
      removeError('cpf');
    }
  }

  function handleEmailChange(event: ChangeEvent<HTMLInputElement>) {
    setEmail(event.target.value);
    if (!event.target.value) {
      setError({ field: 'email', message: 'E-mail é obrigatório!' });
    } else if (!isEmailValid(event.target.value)) {
      setError({ field: 'email', message: 'E-mail inválido!' });
    } else {
      removeError('email');
    }
  }

  function handleTypeChange(type: { value: number, label: string }) {
    setType(type);
    if (type.value === 2) {
      if (JSON.stringify(selectedPermissions) === JSON.stringify(adminPermissions)) {
        setSelectedPermissions(defaultPermissions);
        toast.warn('As permissões foram negadas para todas as páginas. Para personalizar as permissões, basta alterá-las no quadro de permissões');
      }
    } else {
      if (type.value === 3) {
        setSelectedPermissions(defaultPermissions);
        toast.warn('O tipo motorista não tem nenhum acesso permitido ao sistema administrativo, portanto não é possível definir permissões personalizadas para este tipo');
        return;
      }
      if (JSON.stringify(selectedPermissions) === JSON.stringify(defaultPermissions)) {
        setSelectedPermissions(adminPermissions);
        toast.warn('As permissões foram definidas para acesso total a todas as páginas (perfil administrador). Caso queira personalizar as permissões deste perfil, basta alterá-las no quadro de permissões');
      }
    }
  }

  return {
    name,
    cpf,
    email,
    type,
    getErrorMessageByFieldName,
    errors,
    handleNameChange,
    handleCpfChange,
    handleEmailChange,
    handleTypeChange,
    setName,
    setCpf,
    setEmail,
    setType,
  };
}
